/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} YouexamplecomInputs */

const en_youexamplecom = /** @type {(inputs: YouexamplecomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@example.com`)
};

const es_youexamplecom = /** @type {(inputs: YouexamplecomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tu@ejemplo.com`)
};

const fr_youexamplecom = /** @type {(inputs: YouexamplecomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vous@exemple.com`)
};

const de_youexamplecom = /** @type {(inputs: YouexamplecomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`du@beispiel.com`)
};

const ja_youexamplecom = /** @type {(inputs: YouexamplecomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@example.com`)
};

const zh_youexamplecom = /** @type {(inputs: YouexamplecomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@example.com`)
};

const ar_youexamplecom = /** @type {(inputs: YouexamplecomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@example.com`)
};

const id_youexamplecom = /** @type {(inputs: YouexamplecomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`anda@contoh.com`)
};

const it_youexamplecom = /** @type {(inputs: YouexamplecomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tu@esempio.com`)
};

const ru_youexamplecom = /** @type {(inputs: YouexamplecomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@example.com`)
};

const pt_youexamplecom = /** @type {(inputs: YouexamplecomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`voce@exemplo.com`)
};

const ko_youexamplecom = /** @type {(inputs: YouexamplecomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@example.com`)
};

/**
* | output |
* | --- |
* | "you@example.com" |
*
* @param {YouexamplecomInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const youexamplecom = /** @type {((inputs?: YouexamplecomInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<YouexamplecomInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_youexamplecom(inputs)
	if (locale === "es") return es_youexamplecom(inputs)
	if (locale === "fr") return fr_youexamplecom(inputs)
	if (locale === "de") return de_youexamplecom(inputs)
	if (locale === "ja") return ja_youexamplecom(inputs)
	if (locale === "zh") return zh_youexamplecom(inputs)
	if (locale === "ar") return ar_youexamplecom(inputs)
	if (locale === "id") return id_youexamplecom(inputs)
	if (locale === "it") return it_youexamplecom(inputs)
	if (locale === "ru") return ru_youexamplecom(inputs)
	if (locale === "pt") return pt_youexamplecom(inputs)
	return ko_youexamplecom(inputs)
});